import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';
import type { FC, HTMLAttributes } from 'react';

import s from './CardTitle.module.css';

const variants = cva(s.title, {
  defaultVariants: {
    variant: 'primary',
  },
  variants: {
    variant: {
      invert: s.variant_invert,
      neutral: s.variant_neutral,
      primary: s.variant_primary,
    },
  },
});

type CardTitleProps = HTMLAttributes<HTMLParagraphElement> &
  VariantProps<typeof variants> & {
    title: string;
  };

const CardTitle: FC<CardTitleProps> = ({ className, title, variant, ...props }) => (
  <p className={variants({ className, variant })} {...props}>
    {title}
  </p>
);

export { CardTitle };
